export default {
  title: 'Otros'
}
